import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ComponentBase } from '../../_utils/component.base';

@Component({
  selector: 'app-help-popover',
  templateUrl: './help-popover.component.html',
  styleUrls: ['./help-popover.component.scss'],
})
export class HelpPopoverComponent extends ComponentBase {

  constructor(private popoverController: PopoverController) {
    super();
  }

  sendEmail() {
    window.open('mailto:santiago.oddone@simskills.io', '_blank');
    this.popoverController.dismiss();
  }

  async startGuidedVisit() {
    await this.popoverController.dismiss();
    await this.storage.set('guided_visit', true);
    await this.userJourneyService.updateJourneyStatus('lockedVG');
    await this.navigate(['/dashboard']);
  }

}
